// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "f51b9ab-dirty",
    "hash": "f51b9ab",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "f51b9ab-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
